import { makeStyles } from '@material-ui/core';

export const useChipStylesBlue = makeStyles({
  root: {
    borderColor: '#303f9f',
    color: '#303f9f',
  },
});

export const useChipStylesOrange = makeStyles({
  root: {
    borderColor: '#f57c00',
    color: '#f55300',
  },
});

export const useChipStylesDarkOrange = makeStyles({
  root: {
    borderColor: '#cc5500',
    color: '#cc5500',
  },
});

export const useChipStylesGreen = makeStyles({
  root: {
    borderColor: '#4caf50',
    color: '#4caf50',
  },
});

export const useChipStylesGrey = makeStyles({
  root: {
    borderColor: '#808080',
    color: '#808080',
  },
});

export const useChipStylesRed = makeStyles({
  root: {
    borderColor: '#9E1A1A',
    color: '#9E1A1A',
  },
});
